// Fetch parking history
export const FETCH_PARKING_HISTORY = 'FETCH_PARKING_HISTORY';
export const FETCH_PARKING_HISTORY_SUCCESS = 'FETCH_PARKING_HISTORY_SUCCESS';
export const FETCH_PARKING_HISTORY_ERROR = 'FETCH_PARKING_HISTORY_ERROR';
